import api from "./axiosInstance";

const ADMIN_API_URL = "https://api.gosehari.com/admin";
const API_URL = "https://api.gosehari.com"



export const createBookingEnquiry = (token, activityData) => {
  return api.post(API_URL + "/bookingenquiry/create", activityData, {
    headers: { Authorization: `Bearer ${token}` }
  });
};

export const getTopThingsToDoList = (token) => {
  return api.get(API_URL + "/topthings/", {
    headers: { Authorization: `Bearer ${token}` }
  });
};


export const fetchAllTourPlaces = (token, id) => {
  return api.get(`${API_URL}/display-title/`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const fetchTourOverviewById = (token, id) => {
  return api.get(`${API_URL}/overview/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const fetchTourHighlights = (token, tourId) => {
  return api.get(`${API_URL}/highlights/${tourId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const fetchTourPackages = (token, tourId) => {
  return api.get(`${API_URL}/packages/${tourId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const fetchTourItinerary = (token, tourId) => {
  return api.get(`${API_URL}/itinerary/${tourId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};


export const fetchTourTips = (token, thingId) => {
  return api.get(`${API_URL}/tips/${thingId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};


export const fetchTourThingsToBring = (token, thingId) => {
  return api.get(`${API_URL}/bring/${thingId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};


export const fetchTourDurationTimings = (token, thingId) => {
  return api.get(`${API_URL}/duration/${thingId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};


export const fetchTourPickupLocations = (token, thingId) => {
  return api.get(`${API_URL}/pickup/${thingId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};


export const fetchTourInstructions = (token, thingId) => {
  return api.get(`${API_URL}/instructions/${thingId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};


export const fetchTripDetails = (token, thingId) => {
  return api.get(`${API_URL}/trip-details/${thingId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const sendOTP = (data) => {
  return api.post(`${API_URL}/send-otp`, data);
};

export const verifyOTP = (data) => {
  return api.post(`${API_URL}/verify-otp`, data);
};


export const saveBookingInterest = (data) => {
  return api.post(`${API_URL}/save-booking-enquiry`, data);
};




export const verifyPayment = (data) => {
  return api.post(`${API_URL}/verify-payment`, data);
};


// Car Details
export const getCarDetails = (thingId) => {
  return api.get(`${API_URL}/car-details/${thingId}`);
};

export const getCarDetailById = (id) => {
  return api.get(`${API_URL}/car-detail/${id}`);
};

export const createCarDetail = (data) => {
  return api.post(`${API_URL}/car-details`, data);
};

export const updateCarDetail = (id, data) => {
  return api.put(`${API_URL}/car-details/${id}`, data);
};

export const deleteCarDetail = (id) => {
  return api.delete(`${API_URL}/car-details/${id}`);
};

export const saveBookingJourney = (data) => {
  return api.post(`${API_URL}/booking-journey`, data);
};

export const getBookingJourney = (id) => {
  return api.get(`${API_URL}/booking-journey/${id}`);
};

export const getSecureInvoice = (id) => {
    return api.get(`${API_URL}/secure/invoice/${id}`);
};

export const updateBookingJourney = (id, data) => {
  return api.put(`${API_URL}/booking-journey/${id}`, data);
};

export const saveBookingTravelers = (data) => {
  return api.post(
    `${API_URL}/booking-travelers`,
    data
  );
};


export const createPaymentOrder = (data) => {
  return api.post(
    `${API_URL}/create-payment-order`,
    data
  );
};

export const completeBooking = (data) => {
    return api.post(
        `${API_URL}/complete-booking`,
        data
    );
};